import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import storePersist from '../../../../../redux/storePersist';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import BrandMappingComponent from '../components/brand-mapping.component';
import { useSelector } from 'react-redux';
import { selectBrandMappingsQueryItems } from '../../../../../redux/brand-mappings/selector';
import { brandMappings as cmsBrandMappings } from '../../../../../redux/brand-mappings/action';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { websites } from '../../../../../redux/websites/action';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { tenantFunctions } from '../../../../../redux/tenant-functions/action';
import { categories } from '../../../../../redux/categories/action';
import { announcements } from '../../../../../redux/announcements/action';
import { channel } from '../../../../../redux/channel/action';
import { helpTopics } from '../../../../../redux/help-topics/action';
import { discounts } from '../../../../../redux/policy/merchandising/discounts/action';
import { products } from '../../../../../redux/products/action';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { selectTenantFunctionsListItems } from '../../../../../redux/tenant-functions/selector';
import { selectDiscountsListItems } from '../../../../../redux/policy/merchandising/discounts/selector';
import { selectRewardPointsListItems } from '../../../../../redux/policy/merchandising/reward-points/selector';
import { selectAnnouncementsListItems } from '../../../../../redux/announcements/selector';
import { selectHelpTopicsListItems } from '../../../../../redux/help-topics/selector';
import * as R from 'ramda'
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import { selectOrgRegistriesListItems } from '../../../../../redux/org-registries/selector';
import { selectDbasListItems } from '../../../../../redux/dbas/selector';
import { dbas } from '../../../../../redux/dbas/action';
import { orgRegistries } from '../../../../../redux/org-registries/action';
import { selectDeliverysListItems } from '../../../../../redux/policy/shipment/deliveries/selector';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { selectListItems } from '../../../../../redux/library/selector';
import { accountTypes } from '../../../../../redux/account-types/action';
import { ListCriteria } from '../../../types/list-criteria';
import { selectProductsListItems } from '../../../../../redux/products/selector';
import { selectPolicyCollectionsListItems } from '../../../../../redux/organization/collections/selector';
import { policyCollections } from '../../../../../redux/organization/collections/action';
let currentChange: any = {}
const OWNER_TYPE_ACCOUNT = 68

const ManagementBrandMapping = ({ onSubmit, cardDetailInfo }: any) => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const { getUploadFiles } = useAppSelector(selectCurrent)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [logoFiles, setLogoFiles] = useState<any>([])
    const [favFiles, setFavFiles] = useState<any>([])
    const brandMappingsQueryData = useSelector(selectBrandMappingsQueryItems)
    const librariesItems = storePersist?.get("library")?.current;
    const [brandMappings, setBrandMappings] = useState<any>([])
    const [selectedBrand, setSelectedBrand] = useState<any>([])
    const [openFile, setOpenFile] = useState<any>([]);
    const [openConfirmationFile, setOpenConfirmationFile] = React.useState(false);
    const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
    const [openConfirmationFavFile, setOpenConfirmationFavFile] = React.useState(false);
    const [openImageFile, setOpenImageFile] = useState<any>([]);
    const categoriesLists = useSelector(selectCategoriesListItems)
    const productsLists = useSelector(selectProductsListItems)
    const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
    const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
    const rewardsPointsLists = useSelector(selectRewardPointsListItems)
    const discountsLists = useSelector(selectDiscountsListItems)
    const collectionPolicyLists = useSelector(selectPolicyCollectionsListItems)
    const announcementsData = useSelector(selectAnnouncementsListItems)
    const helpTopicsItems = useSelector(selectHelpTopicsListItems)
    const deliveryItemsData = useSelector(selectDeliverysListItems)
    const orgRegistryItems = useSelector(selectOrgRegistriesListItems)
    const accountItems = useSelector(selectAccountsListItems)
    const dbasItems = useSelector(selectDbasListItems)
    const [
        selectedFunctions,
        setSelectedFunctions
    ] = useState<any>([])
    const websitesItems = useSelector(selectWebsitesListItems)
    const webPagesItems = useSelector(selectAccountWebPagesListItems)
    const [accountTypesList, setAccountTypesList] = useState<any>([]);
    const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
    const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const [accountsList, setAccountsList] = useState<any>([])
    const libraryData = useSelector(selectListItems)
    const TypeData = libraryData?.result?.Type
    const [mediaFiles, setMediaFiles] = useState<any>([])


    const listAccountTypes = async () => {
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBAAccountTypes = async () => {
        // v6.1/organization/dbn/dba-type-dba-mappings
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBNBizAccountTypes = async () => {
        // v6.1/organization/dbn/biz-net-types
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
        await dispatch(accounts.resetAction({ actionType: 'list' }))
        await dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
            entity: 'accounts',
            jsonData: {
                "Filters": filterCriteria,
                "Searches": searchCriteria,
                "DateCriteria": dateCriteria,
            }
        }))
    }



    const fetchBrandMappingsQueryById = () => {
        dispatch(cmsBrandMappings.query({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/brand-mappings/query`,
            entity: 'cmsBrandMappings',
            jsonData: {
                Records: [
                    {
                        Id: parmas?.id,
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)

        })
    }

    const handleFormLogoItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
        const items = deepCopy(cardValue.Logos);
        items[idx] = { ...items[idx], [field]: value };
        setLogoFiles(items);
        const updatedCardValue = [...brandMappings];
        updatedCardValue[idx1] = { ...cardValue, Logos: items };
        setBrandMappings(updatedCardValue);
    }

    const handleFormFavItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
        const items = deepCopy(cardValue.Favicons);
        items[idx] = { ...items[idx], [field]: value };
        setFavFiles(items);
        const updatedCardValue = [...brandMappings];
        updatedCardValue[idx1] = { ...cardValue, Favicons: items };
        setBrandMappings(updatedCardValue);
    }

    const handleFormItemBrandChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(brandMappings);
        let item = items[idx];
        item = { ...item, [field]: value }
        items[idx] = item;
        currentChange = { value, field, idx }
        setBrandMappings(items);
    }
    // media handle form change
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedBrand({ ...selectedBrand, [field]: event })
    }

    const handleClose = () => {
        if (openConfirmationFile) {
            setOpenConfirmationFile(false)
        } else if (openConfirmationLogoFile) {
            setOpenConfirmationLogoFile(false)
        } else if (openConfirmationFavFile) {
            setOpenConfirmationFavFile(false)
        }
        dispatch(settings.set({ getUploadFiles: 'close' }))
    }

    const addNewRow = ({ selectedBrandsArg }: any) => {
        const localSelectedBrands = deepCopy(selectedBrandsArg || [])
        const newsBrand = {
            Id: 0,
            Name: '',
            Description: '',
            OwnerLevelId: 0,
            OwnerTypeId: 0,
            OwnerAccountId: 0,


            Logos: [
                {
                    Url: '',
                    Size: '',
                    Background: '',
                }
            ],
            Favicons: [
                {
                    Url: '',
                    Size: '',
                    Background: '',
                }
            ],
            Branding: {
                Primary: {},
                Secondary: {},
                Tertiary: {},
                Ghost: {}
            }
        }
        if (localSelectedBrands.length === 0 ||
            localSelectedBrands[localSelectedBrands?.length - 1]?.Name !== ''
        ) {
            localSelectedBrands?.push(newsBrand);
        }

        return localSelectedBrands
    }

    const addNewLogoFilesRow = ({ selectedLogoFilesArg, brandMapping, idx, idx1 }: any) => {
        const localSelectedlogo = deepCopy(selectedLogoFilesArg || [])
        const newSelectedLogo = {
            Url: '',
            Size: '',
            Background: '',
        }

        if (localSelectedlogo.length === 0 ||
            brandMapping[idx1]?.Logos[brandMapping[idx1].Logos?.length - 1]?.Url !== ''
        ) {

            brandMapping[idx1]?.Logos?.push(newSelectedLogo)
        }

        return localSelectedlogo
    }

    const addNewFavFilesRow = ({ selectedFavFilesArg, brandMapping, idx, idx1 }: any) => {
        const localSelectedfav = deepCopy(selectedFavFilesArg || [])
        const newSelectedFav = {
            Url: '',
            Size: '',
            Background: '',
        }

        if (localSelectedfav.length === 0 ||
            brandMapping[idx1]?.Favicons[brandMapping[idx1].Favicons?.length - 1]?.Url !== ''
        ) {

            brandMapping[idx1]?.Favicons?.push(newSelectedFav)
        }

        return localSelectedfav
    }

    const setCombinationLogoInfo = async () => {
        let localSelectedLogo = deepCopy(logoFiles)
        localSelectedLogo.splice(
            currentChange.idx,
            1,
            { ...localSelectedLogo[currentChange.idx] }
        );
        localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: localSelectedLogo, brandMapping: brandMappings, idx1: currentChange.idx });
        currentChange.field = 'UrlDONE'
        setLogoFiles(localSelectedLogo)
    }

    const setCombinationFavInfo = async () => {
        let localSelectedFav = deepCopy(favFiles)
        localSelectedFav.splice(
            currentChange.idx,
            1,
            { ...localSelectedFav[currentChange.idx] }
        );
        localSelectedFav = addNewFavFilesRow({ selectedFavFilesArg: localSelectedFav, brandMapping: brandMappings, idx1: currentChange.idx });
        currentChange.field = 'UrlDONE'
        setFavFiles(localSelectedFav)
    }

    const setCombinationBrandInfo = async () => {
        let localSelectedbrands = deepCopy(brandMappings)
        localSelectedbrands.splice(
            currentChange.idx,
            1,
            { ...localSelectedbrands[currentChange.idx] }
        );
        localSelectedbrands = addNewRow({ selectedBrandsArg: localSelectedbrands });
        currentChange.field = 'NameDONE'
        setBrandMappings(localSelectedbrands)
    }

    useEffect(() => {
        if (currentChange.field === 'Url') {
            setCombinationLogoInfo()
        }
    }, [currentChange.field, currentChange.idx])

    useEffect(() => {
        if (currentChange.field === 'Url') {
            setCombinationFavInfo()
        }
    }, [currentChange.field, currentChange.idx])

    // useEffect(() => {
    //     if (currentChange.field === 'Name') {
    //         setCombinationBrandInfo()
    //     }
    // }, [brandMappings])

    const handleLogoSubmit = (data: any) => {
        const newLogoFiles = [...logoFiles];
        const logosArray = brandMappings[currentChange.idx1]?.Logos;
        logosArray[currentChange.idx].Url = data;
        const localSelectedLogo = addNewLogoFilesRow({
            selectedLogoFilesArg: newLogoFiles,
            brandMapping: brandMappings,
            idx: currentChange.idx,
            idx1: currentChange.idx1,
            data: data
        });
        setLogoFiles(localSelectedLogo)
    }

    const changeLogoImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenConfirmationLogoFile(true)
        setOpenImageFile({
            currentFileSrc: brandMaping[idx1]?.Logos[idx][templateField],
            folder: 'Organizationunit',
            type: fileType
        })
        currentChange = { idx, templateField, idx1 }
    }

    const changeFavImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
        dispatch(settings.set({ getUploadFiles: 'open' }))
        setOpenConfirmationFavFile(true)
        setOpenImageFile({
            currentFileSrc: brandMaping[idx1]?.Favicons[idx][templateField],
            folder: 'Organizationunit',
            type: fileType
        })
        currentChange = { idx, templateField, idx1 }
    }

    const handleFavSubmit = (data: any) => {
        const newfavFiles = [...favFiles];
        const favsArray = brandMappings[currentChange?.idx1]?.Favicons;
        favsArray[currentChange?.idx].Url = data;
        const localSelectedFav = addNewFavFilesRow({
            selectedFavFilesArg: newfavFiles,
            brandMapping: brandMappings,
            idx: currentChange.idx,
            idx1: currentChange.idx1,
            data: data
        });

        setFavFiles(localSelectedFav)
    }

    useEffect(() => {
        if (!brandMappingsQueryData?.result?.items) return;

        const configItem = brandMappingsQueryData.result.items.Configurations;
        const brandMappingsArr = configItem ? [configItem] : [];

        const brandData = brandMappingsArr.map((item: any) => {
            const logos = item?.Logos?.map((logoItem: any) => ({
                Url: logoItem.Url,
                Size: logoItem.Size,
                Background: logoItem.Background,
            })) || [];

            const favicons = item?.Favicons?.map((favItem: any) => ({
                Url: favItem.Url,
                Size: favItem.Size,
                Background: favItem.Background,
            })) || [];

            // ✅ Always add an extra empty row for Logos and Favicons
            logos.push({ Url: '', Size: '', Background: '' });
            favicons.push({ Url: '', Size: '', Background: '' });

            return {
                Id: brandMappingsQueryData.result.items.Id,
                Name: brandMappingsQueryData.result.items.Name,
                OwnerId: brandMappingsQueryData.result.items.OwnerId,
                OwnerType: brandMappingsQueryData.result.items.OwnerType,
                OwnerTypeId: brandMappingsQueryData.result.items.OwnerTypeId,
                OwnerLevelId: brandMappingsQueryData.result.items.OwnerLevelId || 0,
                OwnerAccountId: brandMappingsQueryData.result.items.OwnerAccountId || 0,
                OwnerLevel: brandMappingsQueryData.result.items.OwnerLevel || "",
                OwnerAccountName: brandMappingsQueryData.result.items.OwnerAccountName || "",
                Description: brandMappingsQueryData.result.items.Description,
                Theme: brandMappingsQueryData.result.items.Theme,
                PrimaryColor: item?.Branding?.Primary?.Color,
                PrimaryBackgroundColor: item?.Branding?.Primary?.BackgroundColor,
                PrimaryBackgroundImage: item?.Branding?.Primary?.BackgroundImage,
                SecondaryColor: item?.Branding?.Secondary?.Color,
                SecondaryBackgroundColor: item?.Branding?.Secondary?.BackgroundColor,
                SecondaryBackgroundImage: item?.Branding?.Secondary?.BackgroundImage,
                TertiaryColor: item?.Branding?.Tertiary?.Color,
                TertiaryBackgroundColor: item?.Branding?.Tertiary?.BackgroundColor,
                TertiaryBackgroundImage: item?.Branding?.Tertiary?.BackgroundImage,
                GhostColor: item?.Branding?.Ghost?.Color,
                GhostBackgroundColor: item?.Branding?.Ghost?.BackgroundColor,
                GhostBackgroundImage: item?.Branding?.Ghost?.BackgroundImage,
                ShortDescription: brandMappingsQueryData.result.items.Stories?.ShortDescription,
                LongDescription: brandMappingsQueryData.result.items.Stories?.LongDescription,
                SearchEngineFriendlyPageName: brandMappingsQueryData.result.items.Stories?.SEO?.SearchEngineFriendlyPageName,
                MetaDescription: brandMappingsQueryData.result.items.Stories?.SEO?.MetaDescription,
                MetaKeywords: brandMappingsQueryData.result.items.Stories?.SEO?.MetaKeywords,
                MetaTitle: brandMappingsQueryData.result.items.Stories?.SEO?.MetaTitle,
                Logos: logos,
                Favicons: favicons,
                Branding: item?.Branding || {},
            };
        });

        // ✅ Set the updated brand mappings (with logo/favicon extra row)
        setBrandMappings(brandData);

        // ✅ Set functions
        const localSelectedService = addNewEntitiesRow({
            selectedFunctionArg: brandMappingsQueryData.result.items?.MappedEntities,
        });
        setSelectedFunctions(localSelectedService);

        // ✅ Directly map logos and favicons for table-level state
        const updatedLogo = brandData.map((brand) => brand.Logos);
        const updatedFav = brandData.map((brand) => brand.Favicons);
        setLogoFiles(updatedLogo);
        setFavFiles(updatedFav);
    }, [brandMappingsQueryData]);

    useEffect(() => {
        setAssociatedAccountTypeId(brandMappings[0]?.OwnerTypeId);
        setOwnerLevelId(brandMappings[0]?.OwnerLevelId);
    }, [brandMappings]);

    useEffect(() => {
        if (associatedAccountTypeId && accountTypesList) {
            const accountTypeName = accountTypesList?.find(
                (item: any) => item.Id === associatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                (type: any) => type.Text === accountTypeName
            )?.Text;
            if (accountTypeValue) {
                listAccountsByType({
                    filterCriteria: [{
                        "FieldName": "Type",
                        "FilterOperatorId": 6,
                        "FieldValue": accountTypeValue,
                        "FieldType": "text"
                    }]
                })
            }
        }
    }, [accountTypesList, associatedAccountTypeId]);




    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                listAccountTypes();
                break;
            case 11:
                listDBAAccountTypes();
                break;
            case 12:
                listDBNBizAccountTypes();
                break;
            default:
                dispatch(accountTypes.resetAction({ actionType: 'list' }))
                break;

        }
    }, [ownerLevelId]);

    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                setAccountTypesList(accountTypeItems?.result?.items);
                setAccountsList([]);
                break;
            case 11:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
                setAccountsList([]);
                break;
            case 12:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
                setAccountsList([]);
                break;
            default:
                setAccountTypesList([]);
                setAccountsList([]);
                break;

        }
    }, [accountTypeItems]);

    useEffect(() => {
        dispatch(accounts.resetAction({ actionType: 'list' }))
        setAccountsList([])
    }, []);

    useEffect(() => {
        setAccountsList(accountItems?.result?.items || [])
    }, [accountItems]);

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        // brandMappings.splice(
        //     brandMappings.length - 1,
        //     1
        // )
        selectedFunctions.splice(
            selectedFunctions.length - 1,
            1
        );

        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )


        const brandData: any = brandMappings.map((item: any) => {
            if (item?.Logos?.length) {
                item.Logos.splice(item.Logos.length - 1, 1);
            }
            if (item?.Favicons?.length) {
                item.Favicons.splice(item.Favicons.length - 1, 1);
            }
            const itemData = {
                Id: item?.Id,
                OwnerType: item?.OwnerType,
                OwnerTypeId: item?.OwnerTypeId,
                OwnerId: item?.OwnerId,
                Name: item?.Name,
                Description: item?.Description,
                Theme: item?.Theme,
                MappedEntities: selectedFunctions,
                
                Configurations: {
                    Logos: item?.Logos?.map((logoItem: any) => {
                        return {
                            Url: logoItem.Url,
                            Size: logoItem.Size,
                            Background: logoItem.Background,
                        };
                    }),
                    Favicons: item?.Favicons?.map((favItem: any) => {
                        return {
                            Url: favItem.Url,
                            Size: favItem.Size,
                            Background: favItem.Background,
                        };
                    }),
                    Branding: {
                        Primary: {
                            Color: item?.PrimaryColor,
                            BackgroundColor: item?.PrimaryBackgroundColor,
                            BackgroundImage: item?.PrimaryBackgroundImage
                        },
                        Secondary: {
                            Color: item?.SecondaryColor,
                            BackgroundColor: item?.SecondaryBackgroundColor,
                            BackgroundImage: item?.SecondaryBackgroundImage
                        },
                        Tertiary: {
                            Color: item?.TertiaryColor,
                            BackgroundColor: item?.TertiaryBackgroundColor,
                            BackgroundImage: item?.TertiaryBackgroundImage
                        },
                        Ghost: {
                            Color: item?.GhostColor,
                            BackgroundColor: item?.GhostBackgroundColor,
                            BackgroundImage: item?.GhostBackgroundImage
                        },

                    },

                },
                Stories: {
                    ShortDescription: item?.ShortDescription,
                    LongDescription: item?.LongDescription,
                    SEO: {
                        SearchEngineFriendlyPageName: item?.SearchEngineFriendlyPageName,
                        MetaDescription: item?.MetaDescription,
                        MetaKeywords: item?.MetaKeywords,
                        MetaTitle: item?.MetaTitle
                    }
                },
                OwnerLevelId: item?.OwnerLevelId || 0,
                OwnerAccountId: item?.OwnerAccountId || 0,
                OwnerLevel: item?.OwnerLevel || "",
                OwnerAccountName: item?.OwnerAccountName || "",
                MediaMappings: {
                    MediaFiles: mediaFiles,
                    Templates: []
                }
            }
            return itemData
        })
        if (parmas?.id > 0) {
            await dispatch(cmsBrandMappings.resetAction({ actionType: 'update' }))
            await dispatch(cmsBrandMappings.update({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/brand-mappings`,
                entity: 'cmsBrandMappings',
                jsonData:
                {
                    Records: brandData
                }
            })).then(() => {
                back()
            })
        } else {
            await dispatch(cmsBrandMappings.resetAction({ actionType: 'create' }))
            await dispatch(cmsBrandMappings.create({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/brand-mappings`,
                entity: 'cmsBrandMappings',
                jsonData:
                {
                    Records: brandData
                }
            })).then(() => {
                back()
            })
        }
    }

    useEffect(() => {

    }, [brandMappings]);

    useEffect(() => {
        dispatch(websites.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
            }
        })).then(() => {
            dispatch(accountWebPages.list({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
                }
            }))
        }).then(() => {
            dispatch(categories.list({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
                entity: 'categories',
                jsonData: {

                }
            }))
        }).then(() => {
            dispatch(products.list({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
                entity: 'products',
                jsonData: {
                }
            }))
        }).then(() => {
            dispatch(accounts.list({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
                entity: 'accounts',
                jsonData: {
                    Context: {},
                    Records: [
                        {
                            IsProxyAccount: false
                        }
                    ],
                    Pagination: {
                    }

                }
            }))
        }).then(() => {
            dispatch(policyCollections.list({
                url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/organization/management/collections/fetch-resultant-policy`,
                entity: 'policyCollections',
                jsonData: {
                    Context: {},
                    Records: [{}],
                    Pagination: {
                    }
                }, options: { key: 'management-product-collection' }
            }))
        }).then(() => {
            dispatch(discounts.list({
                url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/merchandising/management/discounts/list`,
                entity: 'discounts',
                jsonData: {
                    Context: {},
                    Records: [{}],
                    Pagination: {
                    }
                }, options: { key: 'management-product-collection' }
            }))
        }).then(() => {
            dispatch(organizationUnits.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {

                }
            }))
        }).then(() => {
            dispatch(dbas.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/list`,
                entity: 'dbas',
                jsonData: {

                }
            }))
        }).then(() => {
            dispatch(orgRegistries.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/fetch`,
                entity: 'orgRegistries',
                jsonData: {
                    "Context": {},
                    "Records": [{ IsBothTenantANDDBNBased: true }],
                    "Pagination": {

                    }
                }
            }))
            dispatch(tenantFunctions.list({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`, entity: 'tenantDomainFunctions', jsonData: {
                    Filters: [
                        {
                            FieldName: 'IsTemplateMappingEnabled',
                            FieldText: 'TemplateMappingEnabled',
                            FieldType: 'boolean',
                            FilterOperatorId: 1,
                            FieldValue: true
                        }
                    ]


                }
            }))
        })
        if (parmas?.id > 0) {
            fetchBrandMappingsQueryById()
            setIsLoading(false)
        } else {
            const localSelectedBrands = addNewRow({ selectedBrandsArg: brandMappings });
            setBrandMappings(localSelectedBrands)
            const localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: logoFiles, brandMapping: brandMappings, idx1: 0 });
            setLogoFiles(localSelectedLogo)
            const localSelectedService = addNewEntitiesRow({ selectedFunctionArg: selectedFunctions });
            setSelectedFunctions(localSelectedService)
            setIsLoading(false)
        }
    }, [])



    const addNewEntitiesRow = ({ selectedFunctionArg }: any) => {
        const localSelectedFunction = deepCopy(selectedFunctionArg || [])
        const newsFunctions = {
            Id: 0,
            OwnerTypeId: 0,
            OwnerId: 0,
        }
        if (localSelectedFunction.length === 0 ||
            localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerTypeId !== 0
        ) {
            localSelectedFunction?.push(newsFunctions)
        }

        return localSelectedFunction
    }
    const handleFormItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(selectedFunctions);// deep copy of grn items
        let item = items[idx];// deep copy of item to be edited
        item = { ...item, [field]: value }// updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx }
        setSelectedFunctions(items);
    }

    const setCombinationInfo = async () => {
        let localSelectedFunction = deepCopy(selectedFunctions)
        localSelectedFunction.splice(
            currentChange.idx,
            1,
            { ...localSelectedFunction[currentChange.idx] }
        );
        localSelectedFunction = addNewEntitiesRow({ selectedFunctionArg: localSelectedFunction });
        currentChange.field = 'OwnerTypeIdDONE'
        setSelectedFunctions(localSelectedFunction)
    }

    useEffect(
        () => {
            if (currentChange.field === 'OwnerTypeId') {
                setCombinationInfo()
            }
        },
        [selectedFunctions]
    )
    const back = () => {
        navigate(-1)
    }
    const formatWebpagesListData = (data: any) => {
        return _.map(data, (product: any) => {
            const item = {
                Id: product?.Id,
                WebpageName: `${product?.Name} : ${product?.AccountName}`,
            };
            return item
        });
    };
    return (
        <>
            {getUploadFiles == 'open' && openConfirmationLogoFile &&
                <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
                    folder={openImageFile?.folder}
                    handleClose={handleClose}
                    handleFilesSubmit={handleLogoSubmit}
                    type={openImageFile?.type}
                    ownerId={parmas?.id}
                />
            }
            {getUploadFiles == 'open' && openConfirmationFavFile &&
                <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
                    folder={openImageFile?.folder}
                    handleClose={handleClose}
                    handleFilesSubmit={handleFavSubmit}
                    type={openImageFile?.type}
                    ownerId={parmas?.id}
                />
            }
            {isLoading ? <PageLoader /> :
                <BrandMappingComponent
                    handleClose={handleClose}
                    onFormItemBrandChange={handleFormItemBrandChange}
                    logoFiles={logoFiles}
                    changeFavImage={changeFavImage}
                    onFormLogoItemChange={handleFormLogoItemChange}
                    faviconSize={librariesItems.FaviconSize}
                    changeLogoImage={changeLogoImage}
                    logoBackground={librariesItems.LogoBackground}
                    brandMappings={brandMappings}
                    onFormFavItemChange={handleFormFavItemChange}
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    handleFormSubmit={handleFormSubmit}
                    back={back}
                    entityType={libraryData?.result?.BrandMappingEntityType}
                    websites={websitesItems?.result?.items}
                    accounts={accountItems?.result?.items}
                    webpages={webPagesItems?.result?.items}
                    selectedFunctions={selectedFunctions}
                    categories={categoriesLists?.result?.items}
                    announcements={announcementsData?.result?.items}
                    topics={helpTopicsItems?.result?.items}
                    organizationUnits={organizationUnitsLists?.result?.items}
                    discounts={discountsLists?.result?.items}
                    rewards={rewardsPointsLists?.result?.items}
                    collectionPolicies={collectionPolicyLists?.result?.items}
                    deliveries={deliveryItemsData?.result?.items}
                    products={productsLists?.result?.items}
                    handleFormItemChange={handleFormItemChange}
                    tenantFunction={tenantfunctionsLists?.result?.items}
                    dbas={dbasItems?.result.items}
                    accountTypesListLoading={accountTypeItems?.isLoading}
                    accountTypesList={accountTypesList}
                    accountListLoading={accountItems?.isLoading}
                    accountsList={accountsList}
                    isLoading={isLoading}
                    policyOwnerType={libraryData?.result?.PolicyOwnerType}
                    onFormItemChange={handleFormMediaItemChange}
                    orgRegistries={orgRegistryItems?.result.items}
                    tenantFunctions={(tenantfunctionsLists?.result?.items || []).flatMap(
                        (func: any) =>
                            (func.Entities || []).map((entity: any) => ({
                                label: entity.EntityName,       // what to show in dropdown
                                value: entity.Id,               // OwnerTypeId
                                FunctionName: func.FunctionName, // used for conditional logic
                            })))}

                />
            }
        </>
    )
}

export default ManagementBrandMapping;